module.exports = __webpack_public_path__ + "13b9fe9ddb2542b63d44ca64d6f12b49.fbx";